document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('afra-policies-popup');

  if (!popup) return;

  const overlay = popup.querySelector('.afra-popup-overlay');
  const closeBtn = popup.querySelector('.afra-popup-close');
  const okBtn = popup.querySelector('.afra-popup-button');

  const delay = Number(popup.dataset.delay || 2) * 1000;
  const days = Number(popup.dataset.days || 7);

  const storageKey = 'afra-policies-popup';
  const saved = localStorage.getItem(storageKey);

  const now = Date.now();
  const expires = days * 24 * 60 * 60 * 1000;

  if (!saved || now - Number(saved) > expires) {
    setTimeout(() => {
      popup.classList.add('show');
    }, delay);
  }

  function closePopup() {
    popup.classList.remove('show');
    localStorage.setItem(storageKey, Date.now().toString());
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);
  okBtn.addEventListener('click', closePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  });
});